window.lngg = window.lngg || {};
lngg.general__forms__select_option_label = lngg.general__forms__select_option_label || "- Select -";
lngg.product_main__sold_out_option_value = lngg.product_main__sold_out_option_value || " - Sold Out";
lngg.product_main__select_option_label = lngg.product_main__select_option_label || "Select a {{ option_name }}";
lngg.bundle_builder__add_to_bundle_button = "Add to Bundle +";
lngg.bundle_builder__choose_option_label = "Choose a {{ option_name }}:";
lngg.bundle_builder__select_option_message = "* Please select your {{ option_name }}.";


if(!customElements.get('bundle-builder')) {
    class BundleBuilder extends HTMLElement {
        constructor() {
        super();
  
        var config = {
          bundleContainer: this, //bundle box selector
          items: document.querySelectorAll(this.dataset.itemsSelector), //items selector,
          bundleMinItems: parseInt(this.dataset.bundleMinItems), //global minimum required quantity of items in the bundle
          bundleMaxItems: parseInt(this.dataset.bundleMaxItems), //global limit of items in the bundle, 0=no limit
          groupItems: this.dataset.groupItems=='true', // true, or false to view 1 unit item,
          cartBundleMode: this.dataset.cartBundleMode, // "grouped" or "individual",
          showItemsPlaceholder: this.dataset.showItemsPlaceholder=='true',
          stepsContainer: document.querySelector(this.dataset.stepsContainerSelector),
          tagFilters: document.querySelectorAll(this.dataset.filters)
        }

        if (!config.stepsContainer) {
          return;
        }

        //nav & panels behavior
        var btnNavClickHandler = ()=>{};
        if (config.stepsContainer.dataset.navMode == 'step_by_step' || config.stepsContainer.dataset.navMode == 'show_tabs') {
          btnNavClickHandler = function() {
            var switchPanel = true;
            var oldActiveButton = config.stepsContainer.querySelector('.step-nav.active');
            var oldActiveStep = oldActiveButton.dataset.step/1;
            var newStep = this.dataset.step/1;
            if (this.classList.contains('active')) {
              //don't switch if it is the active panel;
              switchPanel = false;
            }
            if (switchPanel) {
              var oldActivePanel = config.stepsContainer.querySelector('.step.active');
              var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
              oldActiveButton.classList.remove('active');
              oldActivePanel.classList.remove('active');
              this.classList.add('active');
              newActivePanel.classList.add('active');
  
            }
          }
        } else {
          btnNavClickHandler = function() {
            var newStep = this.dataset.step/1;
            var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
            $s.scrollToElement(newActivePanel, 60);
          }
        }
        config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn) {
          btn.addEventListener('click', btnNavClickHandler)
        });

        //add tags filter radio event listener
        if (config.tagFilters) {
          config.tagFilters.forEach(function(tagFilter) {
            tagFilter.addEventListener('change', function() {
              Bundler.updateUI();
              setTimeout(function() {
                $s.scrollToElement(config.stepsContainer, 60);
              }, 100);
            })
          })
        }
  
        /* start of builder */
        var Bundler = (function(config) {
          var self = {};
          var container = config.bundleContainer;
          var dataJsonNode = container.querySelector('[type="application/json"]');
          try {
            self.dataJson = JSON.parse(dataJsonNode ? dataJsonNode.textContent : '{}');
          } catch (e) {
            self.dataJson = {progress_steps: [], products_steps: []};
          }
          if (!self.dataJson.products_steps) self.dataJson.products_steps = [];
          if (!self.dataJson.progress_steps) self.dataJson.progress_steps = [];
          self.stats = {count: 0, total: 0, discount_code: '', incomplete_products_steps: self.dataJson.products_steps.map((x,key)=>key).filter(x=>x>0), bundler_discount_badge: self.dataJson.bundler_discount_badge};
  
  
          var itemsAdded = [];
          var uniqIndex = 1;
          var uniq = function() {
            return 'k-' + uniqIndex++;
          }
          var variantUnits = function(id, currentStep) {
            return itemsAdded.reduce((x,y)=>x + (id == y.variant_id && currentStep == y.step  ? y.quantity : 0), 0);
          }
          var productUnits = function(id, currentStep) {
            return itemsAdded.reduce((x,y)=>x + (id == y.product_id && currentStep == y.step ? y.quantity : 0), 0);
          }
          self.add = function(variantId, quantity, htmlItem) {
            var index = itemsAdded.map((x)=>x.variant_id).lastIndexOf(variantId);
            var item;
            if (config.groupItems && index != -1) {
              item = itemsAdded[index];
              item.quantity += quantity
            } else {
              var json = JSON.parse(htmlItem.querySelector('[type="application/json"][data-product-json]').textContent);
              item = {
                variant_id: variantId,
                quantity: quantity,
                key: uniq(),
                product_id: htmlItem.dataset.productId,
                title: htmlItem.querySelector('.title').innerText,
                image: htmlItem.querySelector('.img.main').outerHTML,
                variant: json.variants.find((x)=>x.id==variantId),
                productData: json,
                step: htmlItem.step
              };
              itemsAdded.push(item);
            }
            self.drawItem(item);
            
          }
          self.remove = function(variantId, removeQuantity, currentStep) {
            var index = itemsAdded.map((x)=>{return currentStep==x.step ? x.variant_id : 0}).lastIndexOf(variantId);
            self.removeByIndex(index, removeQuantity);
          }
          self.removeByKey = function(key) {
            var index = itemsAdded.findIndex((x)=>x.key==key);
            var item = itemsAdded[index];
            self.removeByIndex(index, item.quantity);
          }
          self.removeByIndex = function(index, removeQuantity) {
            var item = itemsAdded[index];
            item.quantity -= removeQuantity;
            if (item.quantity == 0) {
              itemsAdded.splice(index, 1);
            }
            self.drawItem(item);
          }
          self.drawItem = function(item) {
            var itemsContainer = container.querySelector('.bundle-items');
            
            var html = `
              <div class="bundle-item" data-key="${item.key}">
                <div class="flex medium-down--direction-column align-items-center">
                  <div class="image-wrapper">
                    <div class="image">${item.image}</div>
                    <button class="remove" aria-label="Remove Item" title="Remove Item">
                        <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-close" viewBox="0 0 32 32"><path fill="" d="M4.2,4.2,27.8,27.8m-23.6,0L27.8,4.2"></path></svg>
                    </button>
                  </div>
                  <div class="info-wrapper flex-1">
                    <div class="flex align-items-center justify-content-between medium-down--justify-content-center medium-down--direction-column">
                        <div class="title p2">${item.title}</div>
                        <div class="price p2"><span class="money">` + $s.formatMoney(item.variant.price).replace('.00', '') + `</span></div>
                    </div>
                    <div class="variant-options p4 medium-down--text-center">
                        ${
                          item.variant.options.map((value,index)=>{
                            return (value != 'Default Title') ? `
                            <div class="option">
                               <span class="option-name">${item.productData.options[index]}:</span> ${value}
                            </div>
                          `: ''}).join('')
                        }
                    </div>
                  </div>
                </div>
              </div>
              `;
            var existingItem = itemsContainer.querySelector('[data-key="' + item.key + '"]');
            if (item.quantity == 0) {
              html = '';
            }
            if (existingItem) {
              existingItem.outerHTML = html;
            } else {
              itemsContainer.insertAdjacentHTML("beforeend", html);
              
            }
            if (html != '') {
              itemsContainer.querySelector('.bundle-item[data-key="' + item.key + '"] .remove').addEventListener('click', function() {
                self.removeByKey(item.key);
              });
            }
            
            self.updateUI(item.step);
          }
          self.drawFormInputs = function() {
            //TODO Subscription updates here (replace variant_id, set subscription properties or selling plan value)
            var html = ''
            var bundleId = new Date().getTime() + '-' + Math.floor(Math.random()*9999 + 1000);
  
            //walk array in reverse order (then cart items order will match what user see in the bundler builder)
            for (var index = itemsAdded.length -1; index>=0; index--) {
              var item = itemsAdded[index];
              var mode = config.cartBundleMode == 'grouped' ? (index==0?'main' : 'related_multiple') : 'individual';
              html += `
                <input type="hidden" name="items[${index}][id]" value="${item.variant_id}">
                <input type="hidden" name="items[${index}][properties[_bundle_id]]" value="${bundleId}">
                <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
                <input type="hidden" name="items[${index}][properties[_bundle_type]]" value="bundle_builder">
                <input type="hidden" name="items[${index}][quantity]" value="${item.quantity}">
                `;
                if (config.cartBundleMode == 'grouped') {
                  html += `
                  <input type="hidden" name="items[${index}][properties[_locked]]" value="quantity">
                    `;
                }
                if (!config.groupItems) {
                html += `
                  <input type="hidden" name="items[${index}][properties[_bundle_position]]" value="${index + 1}">
                  `;
              }
            }
            container.querySelector('.form-inputs').innerHTML = html;
          }
          self.updateUI = function(currentStep) {
            //TODO Subscription updates here (show discounted price, don't change the variant id)
            var itemsContainer = container.querySelector('.bundle-items');
            var totalCount = itemsAdded.reduce((x,y)=>x + y.quantity, 0);
            var totalPrice = itemsAdded.reduce((x,y)=>x + y.variant.price * y.quantity, 0);
            var selectedFilter = Array.from(config.tagFilters).find(x=>x.checked);

            self.stats.count = totalCount;
            self.stats.total = totalPrice;
            self.stats.discounted_price = '';
  
            self.dataJson.products_steps.forEach(function(pd_step, stepIx) {
              var currentStep = stepIx + 1;
              var stepConfig = self.dataJson.products_steps[stepIx];
              var stepContainter = config.stepsContainer.querySelector('.step[data-step="'+currentStep+'"]')
              var itemsAddedFromStep = itemsAdded.filter(x=>x.step==currentStep);
              var totalCountInStep = itemsAddedFromStep.reduce((x,y)=>x + y.quantity, 0);
              if (stepContainter) {
                stepContainter.querySelectorAll('.selected-quantity').forEach(x=>x.innerHTML = totalCountInStep);
              }
  
              var incompleteStepsItemIndex = self.stats.incomplete_products_steps.indexOf(currentStep);
              if (stepConfig.min_items > 0 && totalCountInStep < stepConfig.min_items) {
                if (incompleteStepsItemIndex==-1) {
                  self.stats.incomplete_products_steps.push(currentStep);
                }
              } else if (incompleteStepsItemIndex > -1) {
                self.stats.incomplete_products_steps.splice(incompleteStepsItemIndex, 1);
              }              
  
              config.items.forEach(function(item) {
                if (item.step!=currentStep) {
                  return;
                }

                var productTags = item.dataset.tags || '';
                var filterValue = selectedFilter ? selectedFilter.value : '';
                if (filterValue && productTags.indexOf(filterValue) === -1) {
                  //hide item
                  if (item.parentElement) item.parentElement.style.display = 'none';
                }else{
                  if (item.parentElement) item.parentElement.style.display = '';
                }

                //update number in quantity box (useful when removing items with the X)
                var variantIdInput = item.querySelector('[data-variant-id]');
                var quantityInput = item.querySelector('input[type="number"]');
                if (!variantIdInput || !quantityInput) {
                  return;
                }
                var currentVariantId = variantIdInput.value;
                var currentVariantUnits = variantUnits(currentVariantId, currentStep);
                item.querySelector('input[type="number"]').value = currentVariantUnits;
  
                //disable/enable MINUS button
                item.querySelectorAll('.quantity-button.minus').forEach(function(element) {
                  if (item.querySelector('[type="number"]').value == 0) {
                    element.setAttribute('disabled', true);
                  } else {
                    element.removeAttribute('disabled');
                  }
                });
                
                //disable/enable PLUS and ADD buttons
                item.querySelectorAll('.quantity-button.plus, .btn.add').forEach(function(element) {
                  var variantInput = item.querySelector('[data-variant-id]')
                  var productId = item.dataset.productId;
                  if ( (config.bundleMaxItems > 0 && totalCount>=config.bundleMaxItems)
                    || (stepConfig.max_items > 0 && totalCountInStep>=stepConfig.max_items)
                    || (stepConfig.item_limit > 0 && variantUnits(variantInput.value, currentStep) >= stepConfig.item_limit)
                    || (stepConfig.product_limit > 0 && productUnits(productId, currentStep) >= stepConfig.product_limit) ) {
                    element.setAttribute('disabled', true);
                  } else {
                    element.removeAttribute('disabled');
                  }
                });
              });
  
            });
  
            
            
            //item placeholders
            if (config.showItemsPlaceholder) {
              itemsContainer.querySelectorAll('.item-placeholder').forEach(function(element) {
                element.parentNode.removeChild(element);
              });
              if (config.bundleMaxItems > itemsAdded.length) {
                var placeholders = ``;

                for (var i = 0; i < config.bundleMaxItems - itemsAdded.length; i++) {
                    var isOptional = i >= config.bundleMinItems - itemsAdded.length;

                    placeholders += `
                        <div class="bundle-item item-placeholder">
                        <div class="flex medium-down--direction-column align-items-center">
                            <div class="image-wrapper"><div class="image-placeholder"></div></div>
                            <div class="info-wrapper p2"><div class="info-placeholder flex medium-down--direction-column align-items-center">
                            Select Product
                            ${isOptional ? '<span class="optional badge">Optional</span>' : ''}
                            </div></div>
                        </div>
                        </div>
                        `;
                 }
                    
                itemsContainer.insertAdjacentHTML('beforeend', placeholders);
                
              }
            }
  
  
            //disable/enable ADD BUNDLE TO CART button if conditions not meet
            var enableAddBundle = true;
            var addToCartBtn = container.querySelector('.btn.add');
            var addToCartLabel = addToCartBtn && addToCartBtn.querySelector('.text');
            if (self.stats.incomplete_products_steps.length > 0 || (config.bundleMinItems > 0 && totalCount < config.bundleMinItems)) {
              enableAddBundle = false;
            }
            if (addToCartBtn) {
              if (enableAddBundle) {
                  addToCartBtn.removeAttribute('disabled');
                  if (addToCartLabel) addToCartLabel.textContent = 'Add to cart';
              } else {
                addToCartBtn.setAttribute('disabled', true);
                if (addToCartLabel) addToCartLabel.textContent = `Add ${config.bundleMinItems - totalCount} more Product${config.bundleMinItems - totalCount > 1 ? 's' : ''}`;
              }
            }
  
  
            //disable/enable step nav buttons after a step not completed
            if (config.stepsContainer.dataset.navMode == 'step_by_step') {
              var firstStepIncomplete = null;
              if (self.stats.incomplete_products_steps.length>0) {
                firstStepIncomplete = Math.min(...self.stats.incomplete_products_steps);
              }
              config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn, ix) {
                if (firstStepIncomplete && ix+1 > firstStepIncomplete) {
                  btn.setAttribute('disabled', true);
                } else {
                  btn.removeAttribute('disabled');
                }
              });
            }
  
  
            self.updateProgress();
            
            var itemsLeftContainer = container.querySelector('.items-left');
            if(itemsLeftContainer){
                itemsLeftContainer.innerHTML = config.bundleMinItems - totalCount;
            }
            var finalPrice = self.stats.discounted_price ? self.stats.discounted_price : totalPrice;
            container.querySelectorAll('.subtotal-price').forEach(function(element) {
                element.innerHTML = (finalPrice > 0) ? `
                <span class="deal money">` + $s.formatMoney(finalPrice).replace('.00', '') + `</span>
                ` + (self.stats.discounted_price ? `<span class="retail money">` + $s.formatMoney(self.stats.total) + `</span>` : ``) + `
                ${(self.stats.discount_percentage != null && String(self.stats.discount_percentage).length > 0 && self.stats.discounted_price) ? `<span class="discount badge">${self.stats.bundler_discount_badge.replace('[DISCOUNT_PERCENTAGE]', self.stats.discount_percentage + '%')}</span>` : ``}
                ` : ``;
            });
            
            var stepTitle = config.stepsContainer.querySelector('.step-heading .title');
            if (stepTitle) {
              if(stepTitle.querySelector('.save')) {
                  stepTitle.querySelector('.save').remove();
              }
              var savePercentageElement = document.createElement('span');
              savePercentageElement.className = 'save';
              var rawCallout = self.dataJson.products_steps[0] && self.dataJson.products_steps[0].title_callout;
              var titleCalloutPrefix = (rawCallout !== undefined && rawCallout !== null)
                ? rawCallout
                : 'Save up to ';
              var discountText = self.stats.discount_percentage != null ? self.stats.discount_percentage : '';
              savePercentageElement.textContent = titleCalloutPrefix.replace('[DISCOUNT_PERCENTAGE]', discountText + '%');
              stepTitle.appendChild(savePercentageElement);
            }
  
          }
  
          self.updateProgress = function() {
            //progress bar UI
            if (self.dataJson.progress_steps.length > 0) {
              var steps = self.dataJson.progress_steps;
              var progressType = self.dataJson.progress_type;
              var currentValue = progressType == 'quantity' ? self.stats.count : self.stats.total/100;
              var values = steps.map((step)=>step.value);
              var maxValue = Math.max(...values);
              var completedCaption = container.querySelector('.progress-completed');
              var caption = container.querySelector('.progress-caption');
  
              var progressLongValue = container.querySelector('.progress-value');
              var progressBars = container.querySelectorAll('.progress-bar');
  
              if (self.dataJson.progress_steps_independent) {
                progressBars.forEach(function(progressBar, ix) {
                  var progressValue = progressBar.querySelector('.progress-value');
                  var stepValue = parseFloat(values[ix]) || 0;
                  var barValue = stepValue > 0 ? Math.min(currentValue / stepValue * 100, 100) : 0;
                  if (progressValue) progressValue.style.width = barValue + '%';
                  var dot = progressBar.querySelector('.progress-dot');
                  if (dot) {
                    if (barValue==100) {
                      dot.classList.add('completed');
                    } else {
                      dot.classList.remove('completed');
                    }
                  }
                });
              } else {
                var barValue = maxValue > 0 ? Math.min(currentValue / maxValue * 100, 100) : 0;
                if (progressLongValue) progressLongValue.style.width = barValue + '%';
                progressBars.forEach(function(progressBar, ix) {
                  var prevValue = ix==0 ? 0 : (parseFloat(values[ix-1]) || 0);
                  var stepValue = parseFloat(values[ix]) || 0;
                  if (maxValue > 0) progressBar.style.width = (stepValue - prevValue) / maxValue * 100 + '%';
                  var dot = progressBar.querySelector('.progress-dot');
                  if (dot) {
                    if (stepValue<=currentValue) {
                      dot.classList.add('completed');
                    } else {
                      dot.classList.remove('completed');
                    }
                  }
                });
              }
  
              if (caption) caption.innerHTML = '';
              if (completedCaption) completedCaption.innerHTML = '';
              var stepCompletedIndex = -1;
              for (var i=0; i<steps.length; i++) {
                var step = steps[i];
                if (currentValue < step.value) {
                  //next step
                  var diff = step.value - currentValue;
                  if (caption && step.caption_step_in_progress) {
                    caption.innerHTML = step.caption_step_in_progress
                      .replace('[CURRENT_VALUE]', (progressType=='quantity' ? currentValue : $s.formatMoney(currentValue * 100)) )
                      .replace('[VALUE_REQUIRED]', (progressType=='quantity' ? diff : $s.formatMoney(diff * 100)) );
                  }
                  break;
                } else {
                  stepCompletedIndex = i;
                  if (completedCaption) completedCaption.innerHTML = step.caption_step_completed || '';
                  self.stats.discount_code = step.discount_code || '';
                  if (step.discount_percentage) {
                    self.stats.discounted_price = self.stats.total * (100 - step.discount_percentage) / 100;
                    self.stats.discount_percentage = step.discount_percentage;
                  }
                }
              }            
  
            }
          }
  
          self.openSelectionPopup = function(url, item) {
            var slider = document.querySelector('.product-builder-slider');
            slider.classList.remove('show-required-errors');
            $s.showLoadingOverlay();
            $s.get({
                url: url,
                success: (html)=>{
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, "text/html");
                  var section = doc.querySelector('.product-main-element').closest('.shopify-section');
                  $s.showOverlay();
                  
                  slider.querySelector('.content').innerHTML = section.innerHTML;
                  document.body.appendChild(slider);
                  
                  setTimeout(function(){
                      slider.classList.add('open'); 
                      setTimeout(function() {
                          $s.trapFocus(slider);
                      }, 50);
                  }, 100);

                  var addToCartBtn = slider.querySelector('.btn.add-to-bundle');
                  var productForm = slider.querySelector('form');
                  var optionNamePattern = new RegExp(/{{ *option_name *}}/);
                  var buildChooseLabel = function(optionLabel) {
                    var template = lngg.bundle_builder__choose_option_label || '';
                    var prep = 'aeiou'.indexOf(optionLabel[0].toLowerCase())>-1 ? 'an' : 'a'; //english support only
                    return template.replace('Choose a ', 'Choose ' + prep + ' ').replace(optionNamePattern, optionLabel);
                  };
                  var getOptionControl = function(el) {
                    return el.tagName === 'PRODUCT-DROPDOWN' ? el.querySelector('select') : el;
                  };
                  var getPendingOptions = function() {
                    return slider.querySelectorAll('product-swatch[data-required="true"], product-dropdown[data-required="true"]');
                  };
                  var errorAnnouncer = null;
                  var decorateRequiredOptions = function() {
                    errorAnnouncer = document.createElement('div');
                    errorAnnouncer.className = 'visually-hidden';
                    errorAnnouncer.setAttribute('role', 'alert');
                    errorAnnouncer.setAttribute('aria-live', 'assertive');
                    errorAnnouncer.setAttribute('aria-atomic', 'true');
                    slider.querySelector('.content').appendChild(errorAnnouncer);
                    slider.querySelectorAll('product-swatch, product-dropdown').forEach((el, index)=>{
                      var optionLabel = el.dataset.label;
                      if (!optionLabel || el.dataset.bundleDecorated) {
                        return;
                      }
                      el.dataset.bundleDecorated = 'true';
                      var chooseLabel = buildChooseLabel(optionLabel);
                      var swatchLabel = el.querySelector('.option-label');
                      if (swatchLabel) {
                        swatchLabel.textContent = chooseLabel + ' ';
                      } else {
                        var dropdownLabel = el.querySelector('label.option-name');
                        if (dropdownLabel) {
                          dropdownLabel.childNodes.forEach((node)=>{
                            if (node.nodeType === 3 && node.textContent.indexOf(optionLabel + ':') > -1) {
                              node.textContent = node.textContent.replace(optionLabel + ':', chooseLabel);
                            }
                          });
                        }
                      }
                      if (lngg.bundle_builder__select_option_message) {
                        var message = document.createElement('p');
                        message.className = 'option-required-message';
                        message.id = 'bundle-option-error-' + index;
                        message.textContent = lngg.bundle_builder__select_option_message.replace(optionNamePattern, optionLabel.toLowerCase());
                        el.appendChild(message);
                        var control = getOptionControl(el);
                        if (control) {
                          control.setAttribute('aria-describedby', message.id);
                        }
                      }
                    });
                  };
                  var syncOptionErrors = function() {
                    slider.querySelectorAll('product-swatch, product-dropdown').forEach((el)=>{
                      var control = getOptionControl(el);
                      if (control && el.getAttribute('data-required') !== 'true') {
                        control.removeAttribute('aria-invalid');
                      }
                    });
                    if (errorAnnouncer && getPendingOptions().length === 0) {
                      errorAnnouncer.textContent = '';
                    }
                  };
                  var syncDisabledCta = function() {
                    var requiredBtn = slider.querySelector('.btn.selection-required');
                    if (requiredBtn && lngg.bundle_builder__add_to_bundle_button) {
                      requiredBtn.textContent = lngg.bundle_builder__add_to_bundle_button;
                    }
                  };
                  var scrollToRequiredOption = function() {
                    slider.classList.add('show-required-errors');
                    var pending = getPendingOptions();
                    var messages = [];
                    pending.forEach((el)=>{
                      var control = getOptionControl(el);
                      if (control) {
                        control.setAttribute('aria-invalid', 'true');
                      }
                      var message = el.querySelector('.option-required-message');
                      if (message) {
                        messages.push(message.textContent);
                      }
                    });
                    if (errorAnnouncer) {errorAnnouncer.textContent = '';
                      setTimeout(function() {
                        errorAnnouncer.textContent = messages.join(' ');
                      }, 100);
                    }
                    var firstRequired = pending[0];
                    if (firstRequired) {
                      firstRequired.scrollIntoView({block: 'nearest', inline: 'nearest'});
                      var focusTarget = firstRequired.querySelector('select, input[type="radio"]');
                      if (focusTarget) {
                        focusTarget.focus({preventScroll: true});
                      }
                    }
                  };
                  setTimeout(function() {
                    decorateRequiredOptions();
                    syncDisabledCta();
                  }, 20);
                  var productMain = slider.querySelector('.product-main-element');
                  if (productMain) {
                    productMain.addEventListener('variantChange', syncDisabledCta);
                    productMain.addEventListener('variantChange', function() {
                      setTimeout(syncOptionErrors, 0);
                    });
                  }
                  var popupHasRequiredOptions = function() {
                    var productMain = slider.querySelector('.product-main-element');
                    return !!(productMain && productMain.requiredOptions && productMain.requiredOptions.length > 0);
                  };

                  if (productForm) {
                    productForm.addEventListener('submit', (e)=>{
                      e.preventDefault();
                    });
                  }

                  if (addToCartBtn) {
                    addToCartBtn.addEventListener('click', (e)=>{
                      e.preventDefault();
                      if (popupHasRequiredOptions()) {
                        scrollToRequiredOption();
                        return;
                      }
                      var variantId = slider.querySelector('input[name="id"]').value;
                      if (!variantId) {
                        scrollToRequiredOption();
                        return;
                      }
                      self.add(variantId, 1, item);
                      self.closeSelectionPopup();
                    });
                  }

                  var requiredBtn = slider.querySelector('.btn.selection-required');
                  if (requiredBtn) {
                    requiredBtn.addEventListener('click', scrollToRequiredOption);
                  }

                  slider.querySelector('.close').addEventListener('click', function(event){
                      self.closeSelectionPopup();
                  });

                },
                always: (html)=>{
                  $s.hideLoadingOverlay();
                }
            })
          }

          self.closeSelectionPopup = function() {
            document.querySelector('.product-builder-slider').classList.remove('open');
            $s.hideOverlay();
          }

          function init() {
            container.querySelector('.btn.add').addEventListener('click', function() {
              var add = ()=> {
                self.drawFormInputs();
                var data = new FormData();
                var bundleId = new Date().getTime();
                var bundlePositions = 0;
                var bundlePositionsName = null;

                container.querySelector('.form-inputs').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>{
                  if (!x.name)
                    return;
          
                  if (!x.closest('product-sticky-panel')) {
                    if (x.name.indexOf('_bundle_id') > -1) {
                      x.value = bundleId;
                      bundlePositions++;
                    }
                    else if (x.value == 'main' && x.name.indexOf('_bundle_item') > -1) {
                      bundlePositionsName = x.name.replace('_bundle_item', '_bundle_positions');
                    }
          
                    if (x.type=='file') {
                      if (x.files[0]) {
                        data.append(x.name, x.files[0]);
                      }
                    } else {
                      data.append(x.name, x.value);
                    }
                  }
                });
                if (bundlePositionsName) {
                  data.append(bundlePositionsName, bundlePositions);
                }
                $s.post({
                  url: '/cart/add.js',
                  data: data,
                  success: function(){
                    $s.addToCartSuccess();
                  },
                  error: function(response){
                    $s.addToCartFail(response.description);
                  }
                })
              }
              
              $s.showLoadingOverlay();
  
              if (self.stats.discount_code) {
                $s.get({url: '/discount/'+self.stats.discount_code, success: add})
              } else {
                add();
              }
            });
  
            var expandButton = container.querySelector('.expand-button');
  
            if (expandButton) {
            expandButton.addEventListener('click', function() {
              var panel = container.querySelector('.medium-down--expandable');
              if (this.getAttribute('aria-expanded')=='false') {
                this.setAttribute('aria-expanded', 'true');
                $s.expand([panel]);
              } else {
                this.setAttribute('aria-expanded', 'false');
                $s.collapse([panel]);
              }
            });
            }
  
            config.items.forEach(function(item) {
              var number = item.querySelector('input[type="number"]');
              var variantInput = item.querySelector('input[data-variant-id]');
              var addBtn = item.querySelector('.btn.add');
              var stepEl = item.closest('[data-step]');
              if (!number || !variantInput || !addBtn || !stepEl) {
                return;
              }
              item.step = stepEl.dataset.step/1;
              var currentStep = item.step;
              var stepConfig = self.dataJson.products_steps[currentStep-1] || {};
              var productJsonNode = item.querySelector('[type="application/json"][data-product-json]');
              var productJson = {variants: []};
              try {
                productJson = JSON.parse(productJsonNode ? productJsonNode.textContent : '{"variants":[]}');
              } catch (e) {}
              var buttonText = lngg.bundle_builder__add_to_bundle_button;
              var availableVariants = (productJson.variants || []).filter(x=>x.available);
  
              number.setAttribute('min', '0');
              number.value = 0;
              number.setAttribute('disabled', true);
              if (stepConfig.item_limit) {
                number.setAttribute('max', stepConfig.item_limit);
              }
  
              //Handle quantity change
              number.addEventListener('change', function(event) {
                var diff = this.value - variantUnits(variantInput.value, currentStep);
                if (diff > 0) {
                  self.add(variantInput.value, diff, item);
                } else if (diff < 0) {
                  self.remove(variantInput.value, Math.abs(diff), item.step);
                }
              });
  
              //Handle swatch change
              variantInput.addEventListener('change', function(event) {
                number.value = variantUnits(variantInput.value, currentStep);
                self.updateUI(currentStep);
              });

              //clear existing events and replace button
              var btnDisplay = addBtn.style.display;
              addBtn.outerHTML = `<button type="button" class="btn add v2" style="display: none">${buttonText}</button>`;
              //update internal reference;
              addBtn = item.querySelector('.btn.add');
              if (!addBtn) {
                return;
              }
              addBtn.style.display = btnDisplay;
              var url = addBtn.closest('product-buttons') && addBtn.closest('product-buttons').dataset.bundleUrl;
              addBtn.addEventListener('click', function() {
                if(availableVariants.length > 1) {
                  self.openSelectionPopup(url, item);
                  return;
                }

                self.add(variantInput.value, 1, item);
                number.value = variantUnits(variantInput.value, currentStep);
                self.updateUI(currentStep);
              });
            })

            var template = document.querySelector('#product-builder-form');
            if (template) {
              var clone = template.content.cloneNode(true);
              document.body.appendChild(clone);
            }
            var builderSlider = document.querySelector('.product-builder-slider');

            document.addEventListener('mousedown', function(event){
                if(!builderSlider || (!event.target.closest('.product-builder-slider') && event.target.id!="loading-overlay" && builderSlider.classList.contains('open') && !event.target.classList.contains('tingle-modal') && !event.target.closest('.tingle-modal'))) {
                    self.closeSelectionPopup();
                }
            });
            
            self.updateUI(1);
          }
          
          init();
  
          return self;
        })(config);
  
  
      }
    }
    customElements.define('bundle-builder', BundleBuilder);
  }